/** @jsxRuntime classic */
/** @jsx jsx */
import { FC } from 'react';
import { jsx } from '@emotion/react';
import { AnswerDto, QuestionDto } from '@bondsports/types';
import { FormQuestion } from './FormQuestion';
import { ETypography, ETypographyColor } from '../../../types';
import { Typography } from '../../../atoms';
import { i18n } from '../../../lib/i18n';
import { sectionCss } from '../styles';

interface IProps {
	answers: AnswerDto[];
	questions: QuestionDto[];
}

/**
 * Signed-form responses section used by backoffice print and consumer `/templates/application/[appId]`.
 * @param props - Questionnaire questions and signed answers
 * @returns Stacked printable question list
 */
export const TemplateForm: FC<IProps> = (props: IProps) => {
	const { answers, questions } = props;
	const labels = i18n.applicationTemplate;
	const answersByQuestionId = new Map(answers.map(answer => [answer.questionId, answer.answerValue]));

	return (
		<div css={sectionCss}>
			<Typography color={ETypographyColor.primary} type={ETypography.h4}>
				{labels.formTitle}
			</Typography>
			<div className="questions-container">
				{questions
					.filter(question => answersByQuestionId.has(question.id))
					.map((question: QuestionDto) => (
						<FormQuestion
							question={question}
							answerValue={answersByQuestionId.get(question.id)}
							key={question.id}
						/>
					))}
			</div>
		</div>
	);
};
